exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-page[data-v-2e685489]{padding-top:1rem;height:100%;min-height:100vh;position:relative}.preview-img-item[data-v-2e685489]{cursor:pointer}.img-wrapper[data-v-2e685489]{position:relative}.img-overlay[data-v-2e685489]{position:absolute;top:0;bottom:0;left:0;right:0;text-align:right;margin-right:2%;cursor:pointer}.img-overlay[data-v-2e685489]:before{content:\" \";display:block;height:82%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e685489","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AlbumMosaic.vue
// module id = 402
// module chunks = 0